export default __webpack_public_path__ + "static/media/pin-fu-shin-street.f9fdc9b0.png";